"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tokenHelper_1 = require("./tokenHelper");
class CotterEvent {
    constructor(eventToken) {
        this.ID = eventToken.ID;
        this.CreatedAt = eventToken.CreatedAt;
        this.UpdatedAt = eventToken.UpdatedAt;
        this.DeletedAt = eventToken.DeletedAt;
        this.client_user_id = eventToken.client_user_id;
        this.issuer = eventToken.issuer;
        this.event = eventToken.event;
        this.ip = eventToken.ip;
        this.location = eventToken.location;
        this.timestamp = eventToken.timestamp;
        this.method = eventToken.method;
        this.new = eventToken.new;
        this.approved = eventToken.approved;
        this.signature = eventToken.signature;
    }
    validate() {
        var message = `${this.client_user_id}${this.issuer}${this.event}${this.timestamp}${this.method}${this.new}${this.approved}`;
        var signature = this.signature;
        return tokenHelper_1.ValidateToken(message, signature);
    }
}
exports.default = CotterEvent;
